import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';

import driverLicense from '../images/driver-license.png';
import verifiedBadge from '../images/verified_badge.svg';

import { Colors } from '../themes/colors';

import WarningBanner from '../commonComponents/WarningBanner';
import HeartIcon from '../images/icons/Heart';
import ratingIcon from '../images/star-blue.svg';
import defaultProfile from '../images/HY_tooth.png';
import SkillsMismatchPopup from './SkillsMismatchPopup';
import { extractSkills } from '../commonComponents/CommonFunctions';
import AttendanceBadge from './candidates/AttendanceBadge';
import { growthbook } from '../growthbook';

export default ({ isFavorite, candidate, horizontalCard }) => {
  const user = useSelector((state) => state.user.user);
  const allSkillCategories = useSelector((state) => state.user.allSkillCategories);
  const [showMoreRows, setShowMoreRows] = useState({});
  const [showModal, setShowModal] = useState(false);
  const job = useSelector((state) => state.job.job);
  const licenseNumber = candidate?.license?.credentials?.find(
    ({ entry_field }) => entry_field?.license,
  )?.entry_field?.license;
  const issueDate = candidate?.license?.credentials?.find(
    ({ entry_field }) => entry_field?.issue_date,
  )?.entry_field?.issue_date;

  const {
    userSpecialtySkills,
    jobSpecialtySkills,
    userInsurances,
    jobInsurances,
    userOtherSkills,
  } = extractSkills(allSkillCategories, job, candidate);

  const uniqueSpecialtySkills = [...new Set(userSpecialtySkills?.map(({ name }) => name))];

  const specialtyMismatch = !userSpecialtySkills?.some(({ code }) => code === job.skills[0]?.code)
    && !job.skills[0]?.code?.includes('general');

  const insuranceMismatch = jobInsurances?.length > 0
    && !candidate?.skills?.some((skill) => jobInsurances?.find(({ code }) => code === skill.code));

  const renderWarningDescription = () => {
    if (job.profession === 'DN') {
      let description = '';
      if (specialtyMismatch && insuranceMismatch) {
        description = 'This professional does not have experience in all procedures needed or the same Insurance Provider.';
      } else if (specialtyMismatch) {
        description = 'This professional does not have experience in all procedures needed.';
      } else if (insuranceMismatch) {
        description = 'This professional does not have the same Insurance Provider.';
      }
      return (
        <>
          {description}
        </>
      );
    }
    return (
      <>
        This professional does not have your preferred specialty,
        {' '}
        <strong>{job.skills[0]?.name}</strong>
        .
      </>
    );
  };

  const renderHygInfoRow = (title, value, showWarning) => {
    if (!value) return <></>;

    const rowCode = title.replaceAll(' ', '-');

    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <p className="global_font bold" style={{ margin: 0, color: Colors.neutral_600 }}>
            {title}
          </p>

          {showWarning && (
            <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginLeft: 8 }}>
              <path fillRule="evenodd" clipRule="evenodd" d="M7.90822 1.71858C8.82575 0.0874181 11.1743 0.0874173 12.0918 1.71858L18.7882 13.6232C19.6881 15.2231 18.532 17.1999 16.6964 17.1999H3.30364C1.46806 17.1999 0.311944 15.2231 1.21186 13.6232L7.90822 1.71858ZM11.1999 13.6C11.1999 14.2627 10.6626 14.8 9.9999 14.8C9.33716 14.8 8.7999 14.2627 8.7999 13.6C8.7999 12.9373 9.33716 12.4 9.9999 12.4C10.6626 12.4 11.1999 12.9373 11.1999 13.6ZM9.9999 3.99999C9.33716 3.99999 8.7999 4.53725 8.7999 5.19999V8.79999C8.7999 9.46274 9.33716 9.99999 9.9999 9.99999C10.6626 9.99999 11.1999 9.46274 11.1999 8.79999V5.19999C11.1999 4.53725 10.6626 3.99999 9.9999 3.99999Z" fill="#EA7E00" />
            </svg>
          )}
        </div>

        <p
          className="global_font"
          style={{
            margin: 0,
            color: Colors.neutral_600,
            lineHeight: 1.2,
            maxHeight: showMoreRows[rowCode] && !showMoreRows[rowCode].value ? (16 * 1.2 * 3) : undefined,
            overflow: 'hidden',
          }}
          ref={(ref) => {
            if (!ref) return;

            const divHeight = ref.offsetHeight;
            const lines = Math.round(divHeight / (16 * 1.2));

            if (lines > 3 && !showMoreRows[rowCode]) {
              setShowMoreRows({
                ...showMoreRows,
                [rowCode]: { value: false },
              });
            }
          }}
        >
          {value}
        </p>

        {showMoreRows[rowCode] && !showMoreRows[rowCode].value && (
          <span
            onClick={() => {
              setShowMoreRows({
                ...showMoreRows,
                [rowCode]: { value: true },
              });
            }}
            style={{
              fontFamily: 'Nunito',
              fontWeight: 'bold',
              fontSize: 16,
              color: Colors.primary_500,
              cursor: 'pointer',
            }}
          >
            {'  '}
            ...more
          </span>
        )}
      </div>
    );
  };
  return (
    <div>
      <div style={{
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: horizontalCard ? 'row' : 'column',
      }}
      >
        <div
          style={{
            position: 'relative',
            backgroundColor: '#2fb1c7',
            width: 110,
            height: 110,
            borderRadius: 55,
            alignItems: 'center',
            justifyContent: 'center',
            border: isFavorite ? `3px solid ${Colors.favorites_400}` : 'none',

          }}
        >
          {candidate && candidate.profile_image ? (
            <img
              src={candidate.profile_image}
              style={{
                width: 110,
                height: 110,
                borderRadius: 55,
                objectFit: 'cover',
              }}
              alt="profile_image"
            />
          ) : (
            <div className="default_circle_container">
              <img
                src={defaultProfile}
                alt="profile_image"
                width="50px"
              />
            </div>
          )}
          {isFavorite && (
            <div style={{ position: 'absolute', top: '75%', right: 0 }}>
              <HeartIcon color={Colors.favorites_400} />
            </div>
          )}

        </div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <div style={{ marginLeft: 20 }}>
            <div
              style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                marginTop: 15,
              }}
            >
              <p
                style={{
                  fontSize: 20,
                  color: Colors.neutral_600,
                  fontFamily: 'Nunito',
                  fontWeight: 'bold',
                  margin: '0px 7px 0px 0px',
                }}
              >
                {`${candidate?.first_name} ${candidate?.last_name}`
          || ''}
              </p>

              <img
                src={ratingIcon}
                alt="green"
                style={{
                  width: 20,
                  height: 20,
                  margin: '0px 5px 3px 0px',
                }}
              />

              <span
                style={{
                  fontSize: 16,
                  marginRight: 5,
                  color: Colors.neutral_600,
                  fontFamily: 'Nunito',
                  fontWeight: 'bold',
                }}
              >
                {candidate?.average_rating?.toFixed(1) || '5.0'}
              </span>
            </div>

            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 4,
              }}
            >
              <img
                src={driverLicense}
                style={{ objectFit: 'cover', width: 25 }}
                alt="driver-license"
              />

              <div
                style={{
                  fontFamily: 'Nunito',
                  fontSize: 16,
                  color: Colors.neutral_600,
                }}
              >
                Drivers License Verified
              </div>
            </div>

            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 4,
              }}
            >
              <img
                src={verifiedBadge}
                style={{ objectFit: 'cover', width: 20 }}
                alt="driver-license"
              />

              <div
                style={{
                  fontFamily: 'Nunito',
                  fontSize: 16,
                  color: Colors.neutral_600,
                }}
              >
                {candidate?.license?.profession}
                {' '}
                License Verified
              </div>
            </div>

            {growthbook.isOn('should-show-professional-stats') && (
              <div style={{ textAlign: 'center', marginTop: 25 }}>
                <AttendanceBadge
                  currentRank={candidate?.currentRank}
                />
              </div>
            )}
          </div>
        </div>
      </div>
      <div
        style={{
          width: 380,
          height: 2,
          backgroundColor: Colors.primary_500,
          marginBottom: 2,
          marginTop: 20,
        }}
      />

      {(specialtyMismatch || insuranceMismatch) ? (
        <WarningBanner
          onClick={() => {
            if (specialtyMismatch) {
              setShowModal(true);
            }
          }}
          description={(
            <>
              <strong>Not a Match</strong>
              .
              {' '}
              {renderWarningDescription()}
            </>
          )}
          iconStyle={{ marginLeft: 10 }}
          containerStyle={{ width: 380 }}
          indicatorStyle={{ display: 'none' }}
          primaryColor="#EA7E00"
          secondaryColor="#FEFBF6"
        />
      ) : null}

      <div
        style={{
          width: 380,
          display: 'flex',
          justifyContent: 'space-between',
          marginTop: 20,
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            rowGap: 10,
            width: '40%',
          }}
        >
          {renderHygInfoRow('Profession:', job?.professionName)}
          {renderHygInfoRow('License #:', licenseNumber)}
          {renderHygInfoRow(
            'Issued by State of:',
            candidate?.license?.state,
          )}
          {issueDate
      && renderHygInfoRow(
        'Year Issued:',
        moment(issueDate).format('YYYY'),
      )}
          {renderHygInfoRow(
            'Years of Experience:',
            candidate?.years_of_experience,
          )}
        </div>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            rowGap: 10,
            width: '40%',
          }}
        >
          {renderHygInfoRow('Education:', candidate?.school)}
          {candidate?.graduationDate
      && renderHygInfoRow(
        'Graduation Date:',
        moment(candidate?.graduationDate).format('MM/DD/YYYY'),
      )}
          {renderHygInfoRow(
            job?.profession === 'DN' ? 'Procedures:' : 'Specialty Skills:',
            uniqueSpecialtySkills?.join(', '),
            !candidate?.skills?.some(({ code }) => code === job.skills[0]?.code)
        && !job.skills[0]?.code?.includes('general'),
          )}
          {job?.profession === 'DN' && renderHygInfoRow(
            'Insurance:',
            userInsurances?.map(({ name }) => name)?.join(', '),
            insuranceMismatch,
          )}
          {renderHygInfoRow('Skills:', userOtherSkills?.map(({ name }) => name).join(', '))}
        </div>
      </div>

      { showModal && (
        <SkillsMismatchPopup
          onButtonPress={() => setShowModal(false)}
          missingSkills={jobSpecialtySkills.filter(({ code }) => !userSpecialtySkills.some((skill) => skill.code === code)).map(({ name }) => name).join(', ')}
        />
      ) }
    </div>

  );
};
